import { supabase } from '../lib/supabase';

export const scheduleService = {
  async getAll() {
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    const { data, error } = await supabase?.from('schedules')?.select('*, routes(*)')?.order('created_at', { ascending: false });

    if (error) throw error;

    return data?.map(row => ({
      id: row?.id,
      routeId: row?.route_id,
      startTime: row?.start_time,
      endTime: row?.end_time,
      durationMinutes: row?.duration_minutes,
      frequencyMinutes: row?.frequency_minutes,
      daysMask: row?.days_mask,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at,
      route: row?.routes ? {
        id: row?.routes?.id,
        routeName: row?.routes?.route_name,
        startPoint: row?.routes?.start_point,
        endPoint: row?.routes?.end_point
      } : null
    })) || [];
  },

  async getByRouteId(routeId) {
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    if (!routeId) {
      return [];
    }

    const { data, error } = await supabase?.from('schedules')?.select('*')?.eq('route_id', routeId)?.order('start_time', { ascending: true });

    if (error) throw error;

    return data?.map(row => ({
      id: row?.id,
      routeId: row?.route_id,
      startTime: row?.start_time,
      endTime: row?.end_time,
      durationMinutes: row?.duration_minutes,
      frequencyMinutes: row?.frequency_minutes,
      daysMask: row?.days_mask,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    })) || [];
  },

  async create(schedule) {
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    const { data, error } = await supabase?.from('schedules')?.insert({
        route_id: schedule?.routeId,
        start_time: schedule?.startTime,
        end_time: schedule?.endTime,
        duration_minutes: schedule?.durationMinutes,
        frequency_minutes: schedule?.frequencyMinutes,
        days_mask: schedule?.daysMask
      })?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      routeId: data?.route_id,
      startTime: data?.start_time,
      endTime: data?.end_time,
      durationMinutes: data?.duration_minutes,
      frequencyMinutes: data?.frequency_minutes,
      daysMask: data?.days_mask,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async update(id, schedule) {
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    const { data, error } = await supabase?.from('schedules')?.update({
        route_id: schedule?.routeId,
        start_time: schedule?.startTime,
        end_time: schedule?.endTime,
        duration_minutes: schedule?.durationMinutes,
        frequency_minutes: schedule?.frequencyMinutes,
        days_mask: schedule?.daysMask,
        updated_at: new Date()?.toISOString()
      })?.eq('id', id)?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      routeId: data?.route_id,
      startTime: data?.start_time,
      endTime: data?.end_time,
      durationMinutes: data?.duration_minutes,
      frequencyMinutes: data?.frequency_minutes,
      daysMask: data?.days_mask,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async delete(id) {
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    const { error } = await supabase?.from('schedules')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  async bulkDelete(ids) {
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    const { error } = await supabase?.from('schedules')?.delete()?.in('id', ids);

    if (error) throw error;
  }
};